import React, { useEffect } from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';
import BrandMark from '../brand/BrandMark';

import styles from './ErrorFallback.module.css';
import LocalStorageUtils from '../../../lib/LocalStorageUtils';

function handleBackToHome() {
  window.location.pathname = '/';
}

function ErrorFallback({ error, resetErrorBoundary }) {
  useEffect(() => {
    const chunkLoadingError = /Loading chunk [\d+] failed/;

    if (error?.message && chunkLoadingError.test(error.message)) {
      const pageRefreshCount = LocalStorageUtils.getItemWithExpiry('nexPageRefreshCount');
      if (isNil(pageRefreshCount) || pageRefreshCount !== '1') {
        LocalStorageUtils.saveItemWithExpiry('nexPageRefreshCount', '1', 10000);
        console.log(`retry: ${pageRefreshCount}`);
        window.location.reload();
      }
    }
  }, [error]);

  return (
    <div className={styles.rootContainer}>
      <div className={styles.contentContainer} data-testid="error-screen">
        <div className={styles.logoOuterContainer}>
          <div className={styles.logoInnerContainer}>
            <BrandMark animated={true} />
          </div>
        </div>
        <div className={styles.textContainer}>
          <h1 className={styles.heading}>Oops, something went wrong!</h1>
          <p className={styles.subheading}>
            Please click the button or reload the page to try again.
          </p>
          <div>
            <button
              className={classnames(styles.buttonCta, styles.buttonPrimary)}
              onClick={resetErrorBoundary}
            >
              {`\u27f2 Try Again`}
            </button>

            <button
              onClick={handleBackToHome}
              className={classnames(styles.buttonCta, styles.buttonGray)}
            >
              &larr; Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorFallback;
